import React from 'react';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';

/**
 * ExportOptions Component
 * 
 * Export transcript in various formats
 */
const ExportOptions = ({ onExport, className = '' }) => {
  const formats = [
    { value: 'pdf', label: 'PDF Document', icon: '📑' },
    { value: 'srt', label: 'SRT Subtitles', icon: '📄' },
    { value: 'vtt', label: 'WebVTT', icon: '📹' },
    { value: 'txt', label: 'Plain Text', icon: '📝' },
    { value: 'json', label: 'JSON', icon: '{ }' },
    { value: 'docx', label: 'Word Document', icon: '📋' },
  ];

  return (
    <div className={`space-y-3 ${className}`}>
      <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wider flex items-center gap-2">
        <ArrowDownTrayIcon className="h-4 w-4" />
        Export
      </h3>

      <div className="space-y-2">
        {formats.map((format) => (
          <button
            key={format.value}
            onClick={() => onExport(format.value)}
            className="w-full flex items-center gap-3 px-3 py-2 text-left text-sm font-medium text-gray-700 bg-white border border-gray-200 hover:bg-gray-50 hover:border-gray-300 rounded-lg transition-all"
          >
            <span className="text-lg">{format.icon}</span>
            <span>{format.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ExportOptions;


